/**
 * advanceMatchSimFrame — Run one sim frame unless match already ended (P3-05).
 * Match clock advances only on MatchRuntime (P3-01).
 */
export function advanceMatchSimFrame({
  matchRuntime,
  matchOutcomeWire,
  dt,
  runOrchestratorTick
} = {}) {
  if (!matchRuntime || matchRuntime.isMatchEnded()) return false;
  matchRuntime.advanceTime(dt);
  if (typeof runOrchestratorTick === 'function') runOrchestratorTick();
  if (matchOutcomeWire && typeof matchOutcomeWire.sync === 'function') {
    matchOutcomeWire.sync();
  }
  return true;
}
